var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-open-card',{attrs:{"question":_vm.question,"question-name":(_vm.questionType + " משתנה"),"buttons":_vm.buttons}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0beb8718","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/investigations/cashflow-category/cashflow-category/open-cards/VariableOpenCard.vue
// module id = null
// module chunks = 